'use client';
import React from 'react';
import useMioForm from "../shared/useMioForm.jsx"
import Wrapper from "../shared/Wrapper.jsx"
import { PiMagnifyingGlass } from "react-icons/pi";

function MioText(p) {
    const { mioID, field, isDirty, isInvalid, isTouched } = useMioForm(p.name, p.required);

    return (
        <Wrapper {...p} mioID={mioID} isInvalid={isInvalid} isTouched={isTouched} isDirty={isDirty}>
            <div className={`mtwi ${isInvalid ? 'mtwi-invalid' : ''} ${p.search && 'mtwi-search'}`}>
                <input
                    className={`
                        mio-form-control-input
                        ${p.tabular && 'tabular'}
                        
                        ${p.monospace ? 'monospace' : ''}
                        ${isInvalid ? 'mio-form-control-input-invalid ' : ''}
                        `}
                    id={mioID}
                    type="text"
                    placeholder={p.placeholder}
                    autoComplete="off"
                    {...field}
                    value={field.value ?? ''}
                ></input>
                {p.search && <div className="mio-form-control-icon mio-form-control-icon-search"><PiMagnifyingGlass /></div>}
            </div>
        </Wrapper >
    )
}
export default MioText
{/* {isDirty ? 'dirty' : 'not-dirty'} |
            {isInvalid ? 'invalid' : 'not-invalid'} |
            {isTouched ? 'touched' : 'not-touched'} */}